export default (totalX, totalY) => {
    if (!totalY || totalY === 0) return '--'; // tránh chia cho 0

    const ratio = (totalX / totalY) * 100;
    const rounded = parseFloat(ratio.toFixed(2));

    return rounded === 0 ? '0' : `${rounded}`;
}